import React from 'react'
// import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom';

import { SideBarItem } from '../../../../components';
import { baseUrl } from '../../../../config/baseUrl';

const listSideBarItem = [
  {
    id: 1,
    title: 'Articles',
    path: `${baseUrl}publications`,
  },
  {
    id: 2,
    title: 'Thesis',
    path: `${baseUrl}publications/thesis`,
  },
];

const SideBarPublications = props => {
  const location = useLocation();
  const { pathname } = location;

  return (
    <div>
      {
        listSideBarItem.map((sideBarItem) => (
          <SideBarItem 
            key={sideBarItem.id} 
            title={sideBarItem.title} 
            path={sideBarItem.path} 
            isActive={pathname === sideBarItem.path}
            />
        ))
      }
    </div>
  )
}

SideBarPublications.propTypes = {

}

export default SideBarPublications
